module.exports = __webpack_public_path__ + "img/dana_logo.e9ef07b0.svg";